import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import { LogIn, Sparkles } from "lucide-react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success(`Bem-vindo, ${data.user.name}!`);
      if (data.user.role === "admin") nav("/admin");
      else nav("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen text-white grain">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="glass rounded-3xl p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-full bg-[#FF007F]/10 border border-[#FF007F]/40 flex items-center justify-center">
              <LogIn className="w-5 h-5 text-[#FF007F]" />
            </div>
            <div>
              <span className="text-xs uppercase tracking-[0.2em] text-white/40">
                Entrar
              </span>
              <h1 className="font-display font-black text-2xl tracking-tight">
                Bem-vindo de volta
              </h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Email
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-dark mt-2"
                placeholder="seu@email.com"
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-white/50">
                Senha
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-dark mt-2"
                placeholder="••••••••"
                data-testid="login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-neon w-full mt-4"
              data-testid="login-submit"
            >
              {loading ? "Entrando..." : "Entrar"} <Sparkles className="w-4 h-4" />
            </button>
          </form>

          <p className="mt-6 text-sm text-white/50 text-center">
            Ainda não tem conta?{" "}
            <Link to="/register" className="text-[#00F0FF] hover:underline" data-testid="link-register">
              Criar conta grátis
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
